var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      attrs: { data: _vm.companies, "row-class-name": "cpointer" },
      on: { "row-click": _vm.companySelected }
    },
    [
      _c("el-table-column", {
        attrs: { prop: "name", label: _vm.$t.__("common.labels.society_name") },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("p", [
                  _vm._v(
                    "\n                " +
                      _vm._s(scope.row.name) +
                      "\n                "
                  ),
                  scope.row.companySign
                    ? _c("span", [
                        _vm._v(" (" + _vm._s(scope.row.companySign) + ") ")
                      ])
                    : _vm._e()
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "companyType", label: _vm.$t.__("common.labels.type") }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "companyId", label: _vm.$t.__("common.labels.siren") }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "siret", label: _vm.$t.__("common.labels.siret") }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          prop: "companyJobCode",
          label: _vm.$t.__("common.labels.NAF_code")
        }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "address", label: _vm.$t.__("common.labels.address") }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }